import { Progress } from 'antd';
import React, { memo } from 'react';

import { COLOR_ITEM } from '../const';
import { darkenColor } from '../darkenColor';
import { ItemType } from '../types';

interface IGantItemProgress {
    updatedItem?: ItemType;
    isHidePercentage?: boolean;
    zIndex?: number;
}

const GantItemProgress: React.FC<IGantItemProgress> = ({ updatedItem, isHidePercentage = false }) => {
    return (
        <Progress
            percent={updatedItem?.completionPercentage}
            percentPosition={{ align: 'center', type: 'inner' }}
            size={['100%', 16]}
            strokeColor={darkenColor(updatedItem?.color || COLOR_ITEM, 2000)}
            type={'line'}
            style={{ fontSize: 12, color: 'red' }}
            showInfo={!isHidePercentage}
        />
    );
};

export default memo(GantItemProgress);
